import React, { Component } from 'react';
import PropTypes from 'prop-types';
import color from '../../theme/color';

import { Root, Title, Content, TitleIcon } from './Styles';
import styled from 'styled-components';

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

class Collapsible extends Component {
  state = {
    isActive: false
  };

  updateStatus = () => {
    this.setState({
      isActive: !this.state.isActive
    });
  };

  render() {
    const { title, content } = this.props;

    return (
      <Root>
        <HeaderWrapper onClick={this.updateStatus}>
          <Title>{title}</Title>
          <TitleIcon
            name="chevron"
            color={color.primary}
            isActive={this.state.isActive}
          />
        </HeaderWrapper>
        <Content
          ref={ref => (this.Content = ref)}
          isActive={this.state.isActive}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </Root>
    );
  }
}

Collapsible.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired
};

export default Collapsible;
